<page-toolbar title="{{'pages.dashboard' | translate}}"></page-toolbar>
<page-content [noPadding]="true">
  <div class="container" *ngIf="ready">
    <div class="row personal" *ngIf="!(!dataForDashboard?.length && organisations?.length <= 1 && !reports?.length)">
      <h2>Mein Bereich</h2>
      <div class="content-buttons">
        <interactive-playouts *ngIf="dataForDashboard?.length" [dashboardData]="dataForDashboard"></interactive-playouts>
        <static-playouts [dashboardData]="dataForDashboard"></static-playouts>
      </div>
      <!--<mat-card appearance="outlined" class="monitoring" *ngIf="reports?.length">
        <h3>Device Monitoring</h3>
        <div class="header">
          <div class="type">Device</div>
          <div class="title">Bezeichnung</div>
          <div class="state">Status</div>
        </div>
        <div class="report" *ngFor="let report of reports">
          <div class="type">Touchscreen</div>
          <div class="title">{{ convertTitle(report?.package?.title) }}</div>
          <div class="state {{ getColorClass(report.lastSeen) }}">Zuletzt online: {{ convertTimestamp(report.lastSeen) }}</div>
        </div>
      </mat-card>-->

      <mat-card appearance="outlined" class="organisations" *ngIf="organisations?.length > 1">
        <h3>Organisationen</h3>
        <ng-container *ngFor="let org of organisations">
          <div class="organisation level-{{org.level}}" (click)="selectOrganisation(org)"
               [ngClass]="{ 'visible': parentIsActive(org), active: org.active, 'no-children': !org.children, selected: activeOrganisation.OrganisationID === org.OrganisationID }">
            <div class="inner">
              <mat-icon *ngIf="org.children" (click)="toggleOrgState(org, $event)">chevron_right</mat-icon>
              {{org.name}}
            </div>
          </div>
        </ng-container>
      </mat-card>

      <mat-card appearance="outlined" class="service-ticket">
        <h3>Supportticket</h3>
        <service-ticket></service-ticket>
      </mat-card>
    </div>
    <div class="row ipeak" [ngClass]="{ 'no-personal': (!dataForDashboard?.length && organisations?.length <= 1 && !reports?.length)}">
      <div class="news-container" *ngIf="!!messages?.length">
        <div class="title-container">
          <h2>{{ 'dashboard.news' | translate }}</h2>
          <div class="button" (click)="toggleReadMessages()">
            <mat-icon>{{ showRead ? 'visibility_off' : 'visibility' }}</mat-icon>
            {{ (showRead ? 'dashboard.hideReadMessages' : 'dashboard.showReadMessages') | translate }}
          </div>
        </div>
        <dashboard-message-item (onStatusChange)="statusChanged($event)" *ngFor="let message of messages" [item]="message" [showAll]="showRead"></dashboard-message-item>
      </div>

      <div class="blog-container" *ngIf="blogs && blogs.length">
        <div class="title-container">
          <h2>{{ 'dashboard.ipeakBlog' | translate }}</h2>
          <div class="button" (click)="openBlog('https://ipeak.ch/news/blog/')">
            <mat-icon>language</mat-icon>
          </div>
        </div>
        <div class="blog" *ngFor="let blog of blogs" (click)="openBlog(blog.link)">
          <div class="blog-image" [style.background-image]="'url(' + (blog?.enclosure?.$?.url || blog?.enclosure?.url) + ')'"></div>
          <ibex-line-clamp class="blog-info">
            <div class="title" clampHeader>{{ blog.title }}</div>
            <div class="desc" clampText>{{ blog.description }}</div>
          </ibex-line-clamp>
        </div>
      </div>
    </div>
    <div class="row banner" *ngIf="banners?.length"  [ngClass]="{ 'no-personal': (!dataForDashboard?.length && organisations?.length <= 1 && !reports?.length)}">
      <a *ngFor="let banner of banners; let i = index" class="banner-item" [ngClass]="{ active: i === activeBanner }" [href]="banner.link" target="_blank">
        <img [src]="banner.imageUrl" style="width: 316px;" />
      </a>
      <div class="dots-container">
        <div *ngFor="let banner of banners; let i = index" class="dot" [ngClass]="{ active: i === activeBanner }"
             (click)="activeBanner = i"></div>
      </div>
    </div>
  </div>
</page-content>
